module.exports = __webpack_public_path__ + "static/img/backTo.77e5801e.jpg";